export interface llmInsight {
  customerId?: number;
  insight?: string;
  emoji?: string;
  analysis?: string;
  opening?: string;
  id?: string;
  index?: number;
  html?: string;
}

export interface htmlLlmInsight {
  customerId?: number;
  id?: string;
  index?: number;
  html?: string;
}

export interface otsResults {
  insights: llmInsight[] | htmlLlmInsight[];
  isLoading: boolean;
  error?: string;
}

export type CustomerStatus = {
  status: 'start' | 'processing' | 'completed' | 'fail';
  updatedAt?: string;
  lastUpdated?: string;
  stage?: 'scrape' | 'versionUpdate' | 'featurama' | 'otis';
  currentStep?: 'scrape' | 'versionUpdate' | 'featurama' | 'otis';
  progress?: number; // 0-100 percentage for current stage
  message?: string; // Optional status message
};

export const POLLING_CONFIG = {
  // Maximum time to wait for a 'start' status before considering it stuck (4 minutes)
  TIMEOUT_MS: 4 * 60 * 1000,
  // Maximum time to wait for the entire process before showing timeout warning (5 minutes)
  MAX_PROCESSING_TIME_MS: 5 * 60 * 1000,
  // Interval between status checks (3 seconds)
  POLLING_INTERVAL: 3000,
  // Maximum number of polling attempts before giving up (100 attempts = 5 minutes)
  MAX_ATTEMPTS: 100,
} as const;
